import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class AuthenticatedPlaylistsNewController extends Controller {
  @service router;

  @action cancel() {
    console.log('cancel');
    this.router.transitionTo('authenticated.playlists.index');
  }

  @action async save() {
    console.log('save');
    let playlist = this.get('model.playlist');
    playlist.setProjectIds();
    try {
      await playlist.save();
      playlist.playlistEntries = [];
      this.router.transitionTo('authenticated.playlists.show', playlist.id);
    } catch (err) {
      console.log('we caught an error when saving a comment', err);
    }
  }
}
